import { render, staticRenderFns } from "./require-product.vue?vue&type=template&id=c505e71c"
import script from "./require-product.vue?vue&type=script&lang=js"
export * from "./require-product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports